import IntervalCopyModal from './IntervalCopyModal';

export default IntervalCopyModal;
